import { render } from "./ExperienceSection.vue?vue&type=template&id=f00becf0&ts=true"
import script from "./ExperienceSection.vue?vue&type=script&lang=ts"
export * from "./ExperienceSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__